// We need to initialize common page elements,
// as this entrypoint isn't initialized by the main application.js
import "entry/common"

// Now, we import external libraries necessary to render the content page
import renderContentPromos from "pages/content/renderContentPromos"
import { initializeCommonPageElements } from "pages/common"
import initCustomMetaPixelEvents from "lib/metaPixel"
import initializeContentBody from "lib/content_body"
import trackScrolling from "pages/content/trackScrolling"
import initPodcastFeeds from "pages/content/podcastFeeds"
import initRepublishPromo from "pages/content/initRepublishPromo"
import initMobileToggles from "pages/content/mobileToggles"
import initRelatedContent from "pages/content/relatedContent"
import initCommentSection from "pages/content/commentSection"
import initShareButtons from "pages/content/shareButtons"
import Infographics from "lib/tc/infographics"
import initZoomableImages from "pages/content/zoomableImages"
import initFlashNotices from "pages/content/initFlashNotices"
import localStorageCheck from "lib/localStorageCheck"
import getUserDataWhileRevalidate from "promos/getUserDataWhileRevalidate"
import GTMArticleCompleteEvent from "pages/content/GTMArticleCompleteEvent"
import { trackArticleViewed, trackArticlePageLostFocus } from "lib/tcEventCollector"
import { initialiseActiveTimeOnPage } from "lib/activeTimeOnPage"
import { initialiseScrollDepthTracking } from "lib/articleScrollDepth"
import { incrementTotalArticles } from "@theconversation/shared-libraries/article-read-tracking"
import { trackArticleViewed as trackArticleViewedBraze } from "@theconversation/shared-libraries/braze-tc"
import { initialiseGifClickToPlay } from "lib/gifsClickToPlay"

async function initialize() {
  const {
    comments_closed_at: commentsClosedAt,
    content_id: contentId,
    content_slug: contentSlug,
    promos_context: promosContext,
    subscriptionOptions,
  } = window.PAGE_CONFIG
  const contentBodyEl = document.querySelector("div.content-body")
  const storage = localStorageCheck() ? window.localStorage : undefined
  let user
  const userLoaded = new Promise((resolved) => {
    user = getUserDataWhileRevalidate(storage, resolved)
  })

  if (contentBodyEl) Infographics.init(contentBodyEl)

  initializeCommonPageElements()
  initPodcastFeeds(subscriptionOptions)
  initShareButtons()

  const signal = await renderContentPromos({
    ...promosContext,
    user: {
      donations: user.donations,
      newsletters: user.newsletters,
    },
  })

  userLoaded.then((user) => {
    signal.next({
      type: "newslettersLoaded",
      newsletters: user.newsletters,
    })
    signal.next({
      type: "donationsLoaded",
      donations: user.donations,
    })
  })

  initCustomMetaPixelEvents(contentId)
  initRepublishPromo(contentId)
  initZoomableImages()
  trackScrolling()
  initMobileToggles()
  initRelatedContent()
  GTMArticleCompleteEvent()
  initCommentSection({ contentSlug, contentId, commentsClosedAt })
  initFlashNotices()

  // Track the page view via TC's own event collection
  trackArticleViewed(contentId)

  // Track the page view via Braze
  trackArticleViewedBraze(contentId)

  // Increment the article count, so we know when to initialise Braze
  incrementTotalArticles(contentId)

  // Track how long the user is active on the page:
  initialiseActiveTimeOnPage()

  // Track how far through the article text the user has scrolled:
  initialiseScrollDepthTracking()

  // Emit an event when the article loses focus
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") {
      trackArticlePageLostFocus(contentId)
    }
  })

  if (contentBodyEl) initializeContentBody(contentBodyEl)

  initialiseGifClickToPlay()
}

// Now, let's export the entrypoint initializer, so it's available for the
// `js_page` ERB yield block
TC.EntrypointInitializer = initialize
